import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { SelectForumModalComponent } from 'src/app/select-forum-modal/select-forum-modal.component';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';

@Component({
  selector: 'app-forum-list',
  templateUrl: './forum-list.component.html',
  styleUrl: './forum-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForumListComponent implements OnInit, OnChanges, OnDestroy {
  private destroy$ = new Subject<void>();


  @Output()
  public reloadForums = new EventEmitter();

  @Input({ required: true })
  public forums = []

  @Input({ required: true })
  public pageId;

  @Input()
  public modifyWhenOnSmallDevice = false;

  @Input({ required: true })
  public type: string



  constructor(private sharedService: SharedService,
    private roleService: RoleService, private local: LocalServiceService,
    private auth: AuthServiceService, private toastr: ToastrService,
    private modalService: NgbModal
  ) { }
  ngOnDestroy(): void {
    this._roleSubscription?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['forums']) {
      this.showCarousel = false;

      setTimeout(() => this.showCarousel = true, 500) //force resize
    }
  }
  private _roleSubscription: Subscription | null = null;

  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {
      this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
        this.isUserAnAdmin = this.roleService?.roles?.userType.includes('ADMIN')
      })
      this.local.getUserDetailsObserver().subscribe(user => {
        if (user?.id) {
          this.appUserId = user.id;

        }
      });
    }
  }
  private appUserId;


  public toggleLikeForum(forum) {
    const payload = {
      userId: this.appUserId,
      forumId: forum.forumId,
    };
    this.auth.forum_likes(payload).subscribe({
      next: () => {
        forum.isLiked = !!!forum.isLiked;
      },
      error: err => {
        console.error(err);
        this.toastr.error("somethign went wrong while liking forum")
      }
    })
  }


  public get isOnSmallerDevice(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth < 1600;
  }

  public isUserAnAdmin = false;

  public openForum(forum) {
    window.open(window.location.origin + '/forum/' + forum.slug, '_blank')
  }

  public forumCarouselConfig = {
    autoHeight: true,
    slidesPerView: 1,
    //spaceBetween: 10,
    //navigation: false,
    initialSlide: 0,
  }
  public showCarousel = true;

  public openForumAdd() {
    if (!this.isUserAnAdmin) {
      return;
    }
    const modalRef = this.modalService.open(SelectForumModalComponent, { size: 'sm', centered: true })
    modalRef.componentInstance.type = this.type //this need to be first from product id or whatever params so that the function can decide
    modalRef.componentInstance.pageId = this.pageId

    modalRef.hidden.subscribe(() => { this.reloadForums.next(true); })


  }
  public repliesHolder = ''

  @ViewChild('addComment')
  public addCommentModal;


  public currentSelectedForum = null;

  public openAddCommentModal(forum) {
    this.currentSelectedForum = forum;
    this.modalService.open(this.addCommentModal, { size: 'md', centered: true })
  }

  public addPostToForum() {
    if (!this.repliesHolder) {
      return;
    }
    const form = {
      forumId: this.currentSelectedForum?.forumId,
      message: this.repliesHolder,
      createdBy: this.appUserId,
      // id: id,
      // isChild: isChild,
      // parentChild: parentChild,
    };

    console.log({ form }, this.repliesHolder)
    try {
      this.auth.marketplace_forum_shop_store_reply(form).
        subscribe({
          next: () => {
            this.reloadForums.next(true);
            this.toastr.success("Posted");
            this.modalService.dismissAll();
          },
          error: err => {
            console.error(err);
            this.toastr.error("Something went wrong while posting response")
          }
        });
    } catch (e) {
      console.error(e)
    }
  }

  public repliesHolders = []
}
